import { render, staticRenderFns } from "./CaseManagment.vue?vue&type=template&id=ef6896de"
import script from "./CaseManagment.vue?vue&type=script&lang=js"
export * from "./CaseManagment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports